import { useEffect, useState } from "react";
import { cloneDeep } from "lodash";
import { collection, getDocs, getFirestore } from "firebase/firestore";
import {
  Box,
  Chip,
  Grid,
  InputAdornment,
  Pagination,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

//ui
import ArticleCard from "../components/ArticleCard";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BreadCrumb from "../components/Breadcrumb";
import NewsLetter from "../components/NewsLetter";

//icons
import SearchIcon from "@mui/icons-material/Search";
import { app } from "../firebaseConfig";
import SEO from "../components/SEO";

const Blog = () => {
  const [articles, setArticles] = useState([]);
  const [articlesBackup, setArticlesBackup] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchFilter, setSearchFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  const db = getFirestore(app);

  const navigate = useNavigate();

  useEffect(() => {
    async function getData() {
      //get articles
      const articleCol = collection(db, "articles");
      const articleSnapshot = await getDocs(articleCol);
      let articleList = articleSnapshot.docs.map((doc) => {
        return {
          ...doc.data(),
          id: doc.id,
        };
      });
      articleList = articleList.filter((article) => article.published);

      const pinnedIndex = articleList.findIndex((articolo) => articolo.pinned);
      if (pinnedIndex !== -1) {
        const articoloPinned = articleList.splice(pinnedIndex, 1)[0];
        articleList.sort(
          (a, b) =>
            new Date(
              b.date.seconds * 1000 + Math.round(b.date.nanoseconds / 1e6)
            ) -
            new Date(
              a.date.seconds * 1000 + Math.round(a.date.nanoseconds / 1e6)
            )
        );
        articleList.unshift(articoloPinned);
      }
      setArticles(articleList);
      setArticlesBackup(articleList);

      //get categories
      const categoriesCol = collection(db, "categories");
      const categoriesSnapshot = await getDocs(categoriesCol);
      let categoriesList = categoriesSnapshot.docs.map((doc) => {
        return {
          ...doc.data(),
          id: doc.id,
          active: false,
        };
      });
      categoriesList.sort((a, b) => a.name.localeCompare(b.name));
      setCategories(categoriesList);
    }

    getData();
  }, [db]);

  useEffect(() => {
    let newArticles = cloneDeep(articlesBackup);
    if (categories.length > 0 && articlesBackup.length > 0) {
      let filter = false;
      categories.forEach((category) => {
        if (category.active) filter = true;
      });

      if (filter) {
        newArticles = articlesBackup.filter((article) => {
          const categoryIsActive = categories.find(
            (cat) => cat.name.toLowerCase() === article.category.toLowerCase()
          )?.active;
          return categoryIsActive === true;
        });
      }
    }
    if (searchFilter !== "") {
      newArticles = newArticles.filter((article) =>
        article.title.toLowerCase().includes(searchFilter.toLowerCase())
      );
    }
    setArticles(newArticles);
  }, [categories, searchFilter, articlesBackup]);

  //function that changes the categories
  function handleCategories(key) {
    let cloneCategories = cloneDeep(categories);
    cloneCategories[key].active = !cloneCategories[key].active;
    setCategories(cloneCategories);
  }

  function handleOnChange(evt) {
    setSearchFilter(evt.target.value);
  }

  return (
    <>
      <SEO title="Blog" />
      <Header />
      <section id="blog">
        <Box sx={{ px: 6 }}>
          <Box className="breadCrumbContainer">
            <BreadCrumb />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <TextField
              className="search-filter"
              name="SearchFilter"
              placeholder="Cerca..."
              type="search"
              value={searchFilter}
              onChange={handleOnChange}
              variant="outlined"
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
                sx: {
                  background: "white",
                  borderRadius: "10px",
                },
              }}
              sx={{
                maxWidth: "700px",
                borderRadius: "10px",
              }}
            />
          </Box>
          <Box className="categories-container">
            {categories &&
              categories.length > 0 &&
              categories.map((category, key) => {
                return (
                  <Chip
                    key={key}
                    name={category.name}
                    variant={category.active ? "filled" : "outlined"}
                    onClick={handleCategories.bind(this, key)}
                    color="primary"
                    label={category.name}
                    sx={{
                      fontSize: 16,
                      // textTransform: 'capitalize',
                      borderRadius: "10px",
                    }}
                  />
                );
              })}
          </Box>
        </Box>
        <Grid
          container
          spacing={4}
          sx={{ px: { xs: 2, md: 4, lg: 4, xl: 20 }, my: 2 }}
        >
          {articles && articles.length > 0 ? (
            articles
              .slice(
                (currentPage - 1) * itemsPerPage,
                currentPage * itemsPerPage
              )
              .map((article, _key) => {
                return (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={4}
                    xl={3}
                    key={article.id}
                  >
                    <ArticleCard
                      article={article}
                      onClick={(id) => navigate("/blog/" + id)}
                    />
                  </Grid>
                );
              })
          ) : (
            <Typography variant="h5" className="text-center w-100">
              Nessun articolo disponibile
            </Typography>
          )}
        </Grid>
        <Pagination
          sx={{ margin: "auto", mb: { xs: 4, md: 0 } }}
          count={Math.ceil(articles.length / itemsPerPage)}
          page={currentPage}
          onChange={(_, page) => setCurrentPage(page)}
        />
      </section>
      <NewsLetter />
      <Footer />
    </>
  );
};

export default Blog;
